
import { TabsContent } from "@/components/ui/tabs";
import EmailCard from "./EmailCard";
import { EmailData } from "./types";

interface EmailListProps {
  tabValue: string;
  emails: EmailData[];
}

const EmailList = ({ tabValue, emails }: EmailListProps) => {
  const filteredEmails = emails.filter(email => tabValue === 'all' || email.type === tabValue);
  
  if (filteredEmails.length === 0) {
    return (
      <TabsContent value={tabValue} className="space-y-4">
        <div className="text-center py-6 text-gray-500">
          <p>No emails of this type available</p>
        </div>
      </TabsContent>
    );
  }
  
  return (
    <TabsContent value={tabValue} className="space-y-4">
      {filteredEmails.map((email, index) => (
        <EmailCard key={index} email={email} index={index} />
      ))}
    </TabsContent>
  );
};

export default EmailList;
